export class AuthUserPassword {
  constructor(
    public username: string,
    public password: string,
    public twofacode: string,
    public cachekey?: string, // used for shares
    public wrapKey?: string, // used for shares
    public cfTurnstileToken?: string,
  ) {}
}
